import React, { useEffect } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { getCurrentPosition, startTimer, isTimestampExpired, convertTime } from 'helper';
import LoadingCircle from './LoadingCircle';
import {
    getBrowserLocation, selectBrowserLat, selectBrowserLng,
    selectFormattedAddress, selectLat, selectLng,
    selectName, selectSharingDuration,
    selectSharingOn, selectStartTime,
    selectTimestamp, setExpired, setSharing, setTime,
} from '../../features/liveLocation/liveLocationSlice';
import Address from '../../UI/Address';
import Username from '../../UI/Username';
import InfoText from '../../UI/InfoText';
import Timer from './Timer';
import GetDirectionBtn from '../../UI/GetDirectionBtn';





const LocationInfo = () => {
    const dispatch = useDispatch();
    const name = useSelector(selectName);
    const sharingOn = useSelector(selectSharingOn);
    const sharingDuration = useSelector(selectSharingDuration);
    const formattedAddress = useSelector(selectFormattedAddress);
    const startTime = useSelector(selectStartTime);
    const timestamp = useSelector(selectTimestamp);
    const isLocationExp = useSelector(selectSharingOn);
    const browserLat = useSelector(selectBrowserLat);
    const browserLng = useSelector(selectBrowserLng);
    const lat = useSelector(selectLat);
    const lng = useSelector(selectLng);



    useEffect(() => {
        getCurrentPosition(dispatch, getBrowserLocation);
    }, []);
    
    useEffect(() => {
        if (startTime && sharingDuration) {
            startTimer(startTime, sharingDuration, dispatch, setTime, setSharing);
        } 
    }, [startTime, sharingDuration]);

    useEffect(() => {
        if (timestamp) {
            dispatch(setExpired(isTimestampExpired(timestamp)))

            const timeout = setTimeout(() => {
                dispatch(setExpired(isTimestampExpired(timestamp, 60000)));
            }, 60000);
    
            return () => {
                clearTimeout(timeout);
            };
        }
        
    }, [timestamp]);


    return (
        <div>
            {name && formattedAddress ?
                (<>
                    <Username isDisabled={!sharingOn}>{`${name}’s location`}</Username>
                    <Address isDisabled={!sharingOn}>{formattedAddress}</Address>
                    {isLocationExp && <InfoText>{`Last updated at ${convertTime(moment, timestamp)}`}</InfoText>}
                    <Timer/>
                    <GetDirectionBtn
                        browserLat={browserLat}
                        browserLng={browserLng}
                        lat={lat}
                        lng={lng}
                    >Get Directions</GetDirectionBtn>
                </>) : <LoadingCircle />}
        </div>
    );
   
};


export default LocationInfo;